import { recoverSavedState } from '../actions';

class InteractionInterface {
	constructor(loaderAppElement, loaderExternalInterface, store) {
		this.loaderAppElement = loaderAppElement;
		this.loaderExternalInterface = loaderExternalInterface;
		this.store = store;
		this.type = 'AaMultipleChoice';
	}
	recoverableState({ currentItem, answersSelected, answersMarked, itemsAttempted, correctAnswers, itemsToShow, randomItemsOrder }) {
		let recoverable = false;
		const { exercise } = this.store.getState();
		const itemsLength = exercise.items.length;

		if (
			(currentItem === null || currentItem < itemsLength) &&
			(answersSelected.length <= itemsLength) &&
			(answersMarked.length <= itemsLength) &&
			(itemsAttempted.length <= itemsLength) &&
			(correctAnswers.length <= itemsLength) &&
			(itemsToShow === exercise.itemsToShow) &&
			((randomItemsOrder && exercise.randomItems) || (!randomItemsOrder && !exercise.randomItems))
		) {
			recoverable = true;
		}

		return recoverable;
	}
	recoverSavedState(recoveriesCount, learnerResponse) {
		this.store.dispatch(recoverSavedState(learnerResponse));
	}
	getContainer() {
		return this.loaderAppElement;
	}
	updateInteraction(learnerResponse) {
		const {
			exercise: { currentItem, answersSelected, answersMarked, resultsVisible, totalCorrectAnswers, itemsAttempted, correctAnswers, randomItemsOrder, itemsToShow },
			feedback,
			loader: { testSent, itemsWithAudio }
		} = this.store.getState();

		learnerResponse.currentItem = currentItem;
		learnerResponse.answersSelected = answersSelected;
		learnerResponse.answersMarked = answersMarked;
		learnerResponse.resultsVisible = resultsVisible;
		learnerResponse.totalCorrectAnswers = totalCorrectAnswers;
		learnerResponse.correctAnswers = correctAnswers;
		learnerResponse.itemsAttempted = itemsAttempted;
		if (randomItemsOrder) {
			learnerResponse.randomItemsOrder = randomItemsOrder;
		}
		if (itemsToShow) {
			learnerResponse.itemsToShow = itemsToShow;
		}
		learnerResponse.feedback = feedback.map(e => (e && e.type !== 'recording' && e.type !== 'analysis') ? e : undefined);
		learnerResponse.testSent = testSent;
		learnerResponse.itemsWithAudio = itemsWithAudio;
	}
	hasLoaded() {
		return this.loaderExternalInterface.appLoaded;
	}
	getVersion() {
		return this.store.getState().loader.version;
	}
	getType() {
		return this.type;
	}
}

export default InteractionInterface;
